import Glide from '@glidejs/glide'

const Carousel = (function () {
  const selector = '.js-carousel'
  const elements = document.querySelectorAll(selector)

  const prefersReducedMotion =
    window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
    window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true
  const animationDuration = prefersReducedMotion ? 300 : 750

  const initCarouselElements = () => {
    elements.forEach((carouselEl) => {
      const isVideoCarousel = carouselEl.classList.contains('js-carousel--video')
      const carousel = new Glide(carouselEl, getCarouselOptions(isVideoCarousel))
      carousel.on('run', () => {
        requestAnimationFrame(() => {
          updateActiveBullet(carousel.index, carouselEl)
        })
      })
      carousel.mount()
    })
  }

  /**
   * Modifies default behaviour to update active bullet at start of transition
   * (instead of end).
   */
  const updateActiveBullet = (newIndex, carouselEl) => {
    const activeBulletClass = 'glide__bullet--active'
    const activeBullet = carouselEl.querySelector(`.${activeBulletClass}`)
    const nextActiveBullet = carouselEl.querySelector(`[data-glide-dir="=${newIndex}"]`)

    if (activeBullet && nextActiveBullet) {
      activeBullet.classList.remove(activeBulletClass)
      nextActiveBullet.classList.add(activeBulletClass)
    }
  }

  // See https://glidejs.com/docs/options/
  const getCarouselOptions = (isVideoCarousel) => {
    const type = isVideoCarousel ? 'slider' : 'carousel'
    const autoPlay = isVideoCarousel ? false : 5000

    return {
      type: type,
      perView: 1,
      gap: 0,
      autoplay: autoPlay,
      animationDuration: animationDuration,
      animationTimingFunc: 'ease-in-out',
    }
  }

  return {
    init: () => {
      initCarouselElements()
    },
  }
})()

export default Carousel
